import React from 'react';
import { get } from 'lodash';
import { Grid } from 'semantic-ui-react';

import {
  EDIT_MENU_QUERYSTRINGS,
  EDIT_MENU_TYPES,
} from 'Pages/managemenu/helpers/Constants';

import { ViewPropTypes } from './ViewPropTypes';
import { CycleMenuDay } from './CycleMenuDay';
import { DailyContributions } from './DailyContributions';
import { VIEW_BY } from '../constants';
import {
  formatMonthHeaderText,
  canEditAppliedMenu,
  shouldShowDay,
} from '../utilities';

class MonthView extends React.Component {
  static propTypes = ViewPropTypes;

  renderMenuRow(key, dayHeaders, dayComponents, dayFooters, weekCounter) {
    const { analysisPeriod, onWeekChange } = this.props;
    const weekNumber = weekCounter + 1;

    return (
      <div className="menu-calendar-row" key={key}>
        <Grid padded columns={analysisPeriod}>
          <Grid.Row className="menu-calendar-week" columns={analysisPeriod}>
            <div className="menu-week-label empty" />
            <div className="menu-calendar-headers">{dayHeaders}</div>
          </Grid.Row>
          <Grid.Row className="menu-calendar-week" columns={analysisPeriod}>
            <div className="menu-week-label" onClick={onWeekChange(weekNumber)}>
              <div className="menu-week-text">
                <div className="menu-centered-vertical-text menu-vertical-text">
                  Week
                </div>
                <div className="menu-centered-vertical-text">{weekNumber}</div>
              </div>
            </div>
            {dayComponents}
          </Grid.Row>
          <Grid.Row className="menu-calendar-week" columns={analysisPeriod}>
            <div className="menu-week-label empty" />
            <div className="menu-calendar-footers">{dayFooters}</div>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
  render() {
    const {
      numberOfDays,
      analysisDays,
      menuDaysMap,
      selectMenuItem,
      selectedRecipesById,
      clearSelection,
      recipesById,
      isReadOnly,
      unmetDailyRequirements,
      showDaysOfTheWeek,
      selectedDays,
      disableHover,
      showMealContributionReq,
      onDayClick,
      openRecipe,
      recipeCategories,
      dailyContributions,
      menuType,
      queryParams,
      editableAppliedDays,
      copiedDays,
      copiedRecipesById,
      lassoMode,
      schoolCalendar,
    } = this.props;

    let dayCounter = 0;
    let weekCounter = 0;

    const days = [];
    let dayHeaders = [];
    let dayComponents = [];
    let dayFooters = [];

    let offset = 0;

    for (let i = 0; i < numberOfDays; i++) {
      const currentDay = dayCounter + 1;

      const formatArgs = {
        showDaysOfTheWeek,
        analysisDays,
        dayNumber: currentDay,
      };
      if (menuType === EDIT_MENU_TYPES.APPLIED_MENU) {
        formatArgs.startDate = queryParams[EDIT_MENU_QUERYSTRINGS.START_DATE];
      }

      const canEdit = canEditAppliedMenu({
        menuType,
        editableAppliedDays,
        dayNumber: currentDay,
      });
      const selected = selectedDays[currentDay];
      const copied = copiedDays[currentDay];
      const dailyRequirements = get(unmetDailyRequirements[i], 'List', []);

      if (
        shouldShowDay(
          formatArgs.dayNumber,
          formatArgs.startDate,
          analysisDays,
          schoolCalendar
        )
      ) {
        dayHeaders.push(
          <div
            className="menu-calendar-header hide-text-selection"
            key={`header-${i}`}
          >
            {formatMonthHeaderText(formatArgs)}
          </div>
        );

        dayComponents.push(
          <CycleMenuDay
            key={`day-${currentDay}`}
            dayNumber={currentDay}
            items={menuDaysMap[currentDay] || []}
            index={i}
            selected={selected}
            copied={copied}
            onClick={onDayClick}
            selectMenuItem={selectMenuItem}
            selectedRecipesById={selectedRecipesById}
            copiedRecipesById={copiedRecipesById}
            disableHover={disableHover}
            clearSelection={clearSelection}
            recipeCategories={recipeCategories}
            recipesById={recipesById}
            isReadOnly={isReadOnly || !canEdit || lassoMode}
            dailyRequirements={dailyRequirements}
            showMealContributionReq={showMealContributionReq && canEdit}
            openRecipe={openRecipe}
          />
        );

        dayFooters.push(
          <div className="menu-calendar-footer" key={`footer-${i}`}>
            <DailyContributions
              contributions={dailyContributions[dayCounter]}
              viewType={VIEW_BY.MONTH}
            />
          </div>
        );
      } else {
        offset++;
      }

      dayCounter = currentDay;

      if (i + 1 === numberOfDays) {
        // Check if fillers need to be added
        const slotsRemaining =
          analysisDays - ((numberOfDays - offset) % analysisDays);

        if (slotsRemaining !== analysisDays) {
          for (let j = 0; j < slotsRemaining; j++) {
            dayHeaders.push(
              <div
                className="menu-calendar-header hide-text-selection"
                key={`header-empty-${j}`}
              />
            );
            dayComponents.push(
              <div className="menu-calendar-day" key={`day-empty-${j}`} />
            );
            dayFooters.push(
              <div className="menu-calendar-footer" key={`footer-empty-${j}`} />
            );
          }
        }

        days.push(
          this.renderMenuRow(
            i,
            dayHeaders,
            dayComponents,
            dayFooters,
            weekCounter
          )
        );
      } else if (
        dayComponents.length > 0 &&
        dayComponents.length % analysisDays === 0
      ) {
        days.push(
          this.renderMenuRow(
            i,
            dayHeaders,
            dayComponents,
            dayFooters,
            weekCounter
          )
        );

        weekCounter++;
        dayHeaders = [];
        dayComponents = [];
        dayFooters = [];
      }
    }

    return days;
  }
}

export { MonthView };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/MonthView.js